export var TeamFollowUpReason;
(function (TeamFollowUpReason) {
    TeamFollowUpReason["CALLBACK_REQUESTED"] = "callback_requested";
    TeamFollowUpReason["BROKEN_PROMISE"] = "broken_promise";
    TeamFollowUpReason["ESCALATION_PAST_SCHEDULED"] = "escalation_past_scheduled";
    TeamFollowUpReason["WRONG_NUMBER"] = "wrong_number";
})(TeamFollowUpReason || (TeamFollowUpReason = {}));
export const TeamFollowUpReasonLabels = {
    [TeamFollowUpReason.CALLBACK_REQUESTED]: `Callback requested`,
    [TeamFollowUpReason.BROKEN_PROMISE]: `Broken promise`,
    [TeamFollowUpReason.ESCALATION_PAST_SCHEDULED]: `Escalation past scheduled`,
    [TeamFollowUpReason.WRONG_NUMBER]: `Wrong number`,
};
export var TeamFeedItemType;
(function (TeamFeedItemType) {
    TeamFeedItemType["ACTIVITY"] = "activity";
    TeamFeedItemType["NOTE"] = "note";
    TeamFeedItemType["ESCALATION_CLOSED"] = "escalation_closed";
})(TeamFeedItemType || (TeamFeedItemType = {}));
//# sourceMappingURL=teamActivity.js.map